import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'lastActive',
})
export class LastActivePipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: any): string {
    if (!value) {
      return this.translate.instant('user.never');
    }

    const time = Math.max(0, (Date.now() - Date.parse(value)) / 1000);

    const minutes = Math.floor(time / 60);
    if (minutes < 60) {
      return this.translate.instant(
        `user.last_active_minute.${minutes === 1 ? 'singular' : 'plural'}`,
        { count: minutes },
      );
    }

    const hours = Math.floor(time / 3600);
    if (hours <= 24) {
      return this.translate.instant(
        `user.last_active_hour.${hours === 1 ? 'singular' : 'plural'}`,
        { count: hours },
      );
    }

    const days = Math.floor(time / 86400);
    return this.translate.instant(`user.last_active_day.${days === 1 ? 'singular' : 'plural'}`, {
      count: days,
    });
  }
}
